export enum BusinessType {
  ZZP = 'zzp',
  EENMANSZAAK = 'eenmanszaak',
  WINKEL = 'winkel',
  KANTOOR = 'kantoor',
  INDUSTRIEEL = 'industrieel',
}
